import { createOrganizationDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createOrganizationCallable = getCallable(
  createOrganizationDefinition,
);
